module.exports = __webpack_public_path__ + "img/januca-2018-thumbnail.829527db.jpg";